import type { App } from 'vue'
import { getCurrentInstance } from 'vue'

interface TurboLinksPlugin {
  install(app: App): void
}

const TurboLinksPlugin: TurboLinksPlugin = {
  install(app: App) {
    app.mixin({
      mounted() {
        const instance = getCurrentInstance()
        const element = instance?.proxy?.$el as HTMLElement

        const unmountCallback = (): void => {
          if (instance && element && element.parentNode) {
            app.unmount()
          }
        }

        if (instance && instance.uid === instance.root?.uid) {
          // Must stay on document: page teardowns rely on running after Vue
          // unmount.
          document.addEventListener(
            // eslint-disable-next-line no-restricted-syntax
            'turbolinks:before-cache',
            unmountCallback,
            {
              once: true,
            }
          )

          document.addEventListener(
            // eslint-disable-next-line no-restricted-syntax
            'turbolinks:before-render',
            unmountCallback,
            {
              once: true,
            }
          )
        }
      },
    })
  },
}

export default TurboLinksPlugin
